/**
 * GradeBenefitsPresenter
 * --
 */
import React from 'react';
import { Content, Title } from 'components';
import './GradeBenefitsPresenter.style.css';
import Benefit from 'assets/jm_grade.jpg';

const GradeBenefitsPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const { screenSize, isCommon = false } = props;
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /* ===== Hooks ===== */
  /* ===== RENDER ===== */
  return (
    <Content
      className="grade_benefits"
      maxWidth={'100%'}
      style={{
        padding: !isCommon
          ? screenSize >= 768
            ? '100px 0'
            : '60px 0'
          : '30px 0px 0px',
      }}
    >
      <Title
        align="center"
        style={{
          fontSize: screenSize >= 768 ? 40 : screenSize >= 500 ? 28 : 20,
          lineHeight: '150%',
        }}
      >
        멤버십 등급 혜택
      </Title>

      <div
        className={`grade_bar ${isCommon ? 'common_grade_bar' : ''}`}
        style={{ maxWidth: 1100 }}
      >
        {/* <div className="bar_wrap">
          <div>
            <p>VVIP</p>
            <p>80만원 이상</p>
          </div>
          <div>
            <p>VIP</p>
            <p>50만원 이상</p>
          </div>
          <div>
            <p>GOLD</p>
            <p>30만원 이상</p>
          </div>
          <div>
            <p>SILVER</p>
            <p>10만원 이상</p>
          </div>
          <div>
            <p>WELCOME</p>
            <p>10만원 미만</p>
          </div>
        </div> */}
        <img src={Benefit} alt="등급혜택" width={'100%'} />
      </div>

      {/* <div
        className="info"
        style={{
          maxWidth: 1300,
          display: 'flex',
          flexDirection: screenSize >= 768 ? 'unset' : 'column',
          justifyContent: screenSize >= 768 ? 'space-between' : 'unset',
          alignContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <ul
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '16px 0',
            color: 'var(--black-color)',
            lineHeight: 1.75,
          }}
        >
          <li
            style={{
              marginBottom: 16,
              fontWeight: 700,
            }}
          >
            멤버십 등급 기준 안내
          </li>
          <li>
            최근 {setting?.total_month_standard}개월 동안 구매 확정된 누적 실
            결제금액을 기준으로 매월
            {setting?.date_of_change}일 새로운 등급이 부여됩니다.
          </li>
          <li>
            실 결제금액은 포인트, 쿠폰 등 할인 금액을 제외한 결제금액 입니다.
          </li>
          <li>
            예상 등급이란 멤버십 산정 기준에 따라 익월 {setting?.date_of_change}
            일 반영 예정인 등급입니다.
          </li>
          <li>
            멤버십 혜택 및 산정 기준은 당사의 사정에 의해 변경될 수 있습니다.
          </li>
          <li>온라인과 오프라인 구매 실적 포인트는 제품별 상이합니다.</li>
        </ul>
        <ul
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '16px 0',
            color: 'var(--black-color)',
            lineHeight: 1.75,
          }}
        >
          <li
            style={{
              marginBottom: 16,
              fontWeight: 700,
            }}
          >
            멤버십 혜택 안내
          </li>
          <li>
            등급별로 혜택이 상이하며, 모든 등급쿠폰은 매월 1일부터 말일까지 사용
            가능합니다.
          </li>
          <li>
            무료배송 쿠폰은 GOLD 등급 이상 고객님께만 발급되며, 제이엠커피
            자사브랜드에 한해 적용 가능합니다.
          </li>
          <li>유효기간이 만료된 쿠폰은 재발급이 불가능합니다.</li>
          <li>
            상품 구매 포인트는 상품 구매 확정시 실 결제금액 기준으로 지급되며,
            브랜드/제품별로 포인트 적립률이 상이합니다.
          </li>
          <li>장바구니쿠폰은 결제 금액별 적용 가능쿠폰이 상이합니다.</li>
          <li>
            제이엠 자사브랜드: 최대 1.0%, 입점사: 최대 0.5%, 오프라인 구매 실적
            최대 1.0%
          </li>
          <li>행사제품 면세제품은 적립 제외</li>
          <li>모든 쿠폰은 중복사용 불가</li>
          <li>매장제조/베이커리 상품은 포인트지급이 되지 않습니다.</li>
          <li>
            매장제조음료 상품은 스탬프지급 / 10잔 이용시 1잔 무료 아메리카노
            교환 쿠폰 발행
          </li>
        </ul>
      </div> */}
    </Content>
  );
};

export default GradeBenefitsPresenter;
